var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SystemToken } from '@paysera/auth-api-authentication-client';
class TokenService {
    constructor(authClient, storageKey) {
        this.authClient = authClient;
        this.token = null;
        this.refreshTokenPromise = null;
        this.storageKey = storageKey;
        this.token = sessionStorage.getItem(this.storageKey);
    }
    getToken(scope, scopeSystem) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.token) {
                return this.token;
            }
            return this.refreshToken(scope, scopeSystem);
        });
    }
    refreshToken(scope, scopeSystem) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.refreshTokenPromise) {
                this.refreshTokenPromise = this.authClient
                    .createStrictSystemToken(new SystemToken({
                    scope,
                    audience: scopeSystem,
                }))
                    .then((tokenResponse) => {
                    this.token = tokenResponse.getSystemToken().getValue();
                    if (this.token) {
                        sessionStorage.setItem(this.storageKey, this.token);
                    }
                    this.refreshTokenPromise = null;
                    return this.token;
                })
                    .catch((error) => {
                    this.refreshTokenPromise = null;
                    throw error;
                });
            }
            return this.refreshTokenPromise;
        });
    }
    clearToken() {
        this.token = null;
        sessionStorage.removeItem(this.storageKey);
    }
}
export default TokenService;
